






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IContractor, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'contractor',
  }),
  mixins: [paginationMixin],
})
export default class ContractorList extends Vue {
  @Action('getEntities', { namespace: 'contractor' }) getEntities: () => void;
  @Action('deleteEntities', { namespace: 'contractor' })
  deleteEntities: () => void;

  @Getter('entitiesSlice', { namespace: 'contractor' })
  entitiesSlice: IContractor[];
  @State('pageParams', { namespace: 'contractor' }) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Город', value: 'location' },
    { text: 'Тип', value: 'company_type.name' },
  ];
  filters = [
    {
      searchKey: 'name',
      label: 'Название',
      component: 'v-text-field',
      itemText: 'name',
    },
    {
      searchKey: 'location',
      label: 'Город',
      component: 'v-text-field',
      itemText: 'location',
    },
    {
      searchKey: 'company_type_id',
      label: 'Тип',
      url: '/company_type',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      itemText: 'name',
    },
  ];
  created() {
    this.getEntities();
  }
}
